type Texts = {
    title: string;
    description: string;
    backButtonText?: string;
    infoDescription?: string;
    continueButtonText: string;
};

export enum SUBSCRPTION_TYPE {
    TRIAL = 'TRIAL',
    TASTING = 'TASTING',
    FULL = 'FULL'
}

const getVoyoPackageTexts = (type?: SUBSCRPTION_TYPE): Texts => {
    switch (type) {
        case SUBSCRPTION_TYPE.TRIAL:
            return {
                title: 'PARTNER.VOYO.PACKAGE1_TRIAL_TITLE_MOBILES',
                description: 'PARTNER.VOYO.PACKAGE1_TRIAL_DESCRIPTION1_MOBILES',
                infoDescription: 'PARTNER.VOYO.PACKAGE1_TRIAL_DESCRIPTION2_MOBILES',
                backButtonText: 'PARTNER.VOYO.CLOSE_BTN',
                continueButtonText: 'PARTNER.VOYO.CONTINUE_ORDER_PACKAGE2_BTN_MOBILES'
            };

        case SUBSCRPTION_TYPE.TASTING:
            return {
                title: 'PARTNER.VOYO.PACKAGE1_TITLE_MOBILES',
                description: 'PARTNER.VOYO.PACKAGE1_DESCRIPTION_MOBILES',
                infoDescription: 'PARTNER.VOYO.PACKAGE1_INFO_DESCRIPTION_MOBILES',
                backButtonText: 'PARTNER.VOYO.CLOSE_BTN',
                continueButtonText: 'PARTNER.VOYO.CONTINUE_ORDER_PACKAGE2_BTN_MOBILES'
            };
        case SUBSCRPTION_TYPE.FULL:
            return {
                title: 'PARTNER.VOYO.PACKAGE2_TITLE_MOBILES',
                description: 'PARTNER.VOYO.PACKAGE2_DESCRIPTION_MOBILES',
                continueButtonText: 'PARTNER.VOYO.UNDERSTAND_BTN'
            };
        default:
            console.log('No valid subscription.');
            return {
                title: '',
                description: '',
                continueButtonText: ''
            };
    }
};

export default getVoyoPackageTexts;
